import React from "react";
import HeroSection from "../sectionBlocks/HeroSection";
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import Award from "../sectionBlocks/Awards";
import Footer from "../sectionBlocks/Footer";
import {Helmet} from "react-helmet";
import LazyLoad from 'react-lazyload';


function Home({data, loading, error, localData}) {
  return (
    <>
      <Helmet>
        <title>PopBelly NFTs</title>
        <meta
          name={"description"}
          content={"PopBelly collection of NFTs available on Opensea, Rarible and Foundation"}
        />
        <meta
          name={"keywords"}
          content={"NFT, Blockchain, Art"}
        />
      </Helmet>
      <HeroSection/>
      {/* <StaticCategoriesAd /> */}
      <div style={{marginTop: "5rem"}}>
        <NFTMarketPlace 
          displayCollectionName = {``} 
          collectionName = {`People NFT PopBeLLy ANIMATED Collection`} 
          displayPagination = {`dn`} 
          displayLink = {``} 
          linkAddress = {`/markets/videos/people`} 
          linkTitle = {`See more People Animated videos ->`} 
          fetchingCardsRule = {({meta}) => meta.content[0] && meta.content[1] && meta.attributes[0].value === "People"} 
          sliceStart = {15} 
          sliceEnd = {20}
          loading = {loading} 
          error = {error} 
          data = {data} 
          localData = {localData}
        />
        <NFTMarketPlace 
          displayCollectionName = {``} 
          collectionName = {`BedroOms and MaNCaVes NFT ANIMATED PopBeLLy Collection`} 
          displayPagination = {`dn`} 
          displayLink = {``} 
          linkAddress = {`/markets/videos/mancaves-and-bedrooms`} 
          linkTitle = {`See more Bedroom and Mancaves Animated NFT ->`} 
          fetchingCardsRule = {({meta}) => (meta.content[1] && meta.attributes[0].value === "Mancave") || (meta.content[1] && meta.attributes[0].value === "Bedroom")} 
          sliceStart = {8} 
          sliceEnd = {13}
          loading = {loading} 
          error = {error} 
          data = {data} 
          localData = {localData}
        />
        <NFTMarketPlace 
          displayCollectionName = {``} 
          collectionName = {`People NFT pictures PopBeLLy Collection`} 
          displayPagination = {`dn`} 
          displayLink = {``} 
          linkAddress = {`/markets/pictures/people`} 
          linkTitle = {`See more People NFT Pictures ->`} 
          fetchingCardsRule = {({meta}) => meta.content[1] === undefined && meta.attributes[0].value === "People"} 
          sliceStart = {0} 
          sliceEnd = {5}
          loading = {loading} 
          error = {error} 
          data = {data} 
          localData = {localData}
        />
        <LazyLoad>
          <NFTMarketPlace 
            displayCollectionName = {``} 
            collectionName = {`BedroOms and MaNCaVes NFT pictures PopBeLLy Collection`} 
            displayPagination = {`dn`} 
            displayLink = {``} 
            linkAddress = {`/markets/pictures/mancaves-and-bedrooms`} 
            linkTitle = {`See more Mancaves and Bedrooms NFTs Pictures ->`} 
            fetchingCardsRule = {({meta}) => (meta.content[1] === undefined && meta.attributes[0].value === "Mancave") || (meta.content[1] === undefined && meta.attributes[0].value === "Bedroom")} 
            sliceStart = {0} 
            sliceEnd = {5}
            loading = {loading} 
            error = {error} 
            data = {data} 
            localData = {localData}
          />
        </LazyLoad>
      </div>
      <Award/>
      <Footer/>
    </>
  );
}

export default Home;
